import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditSchool from '../../components/schools/FormAddEditSchool';

const CreateSchool = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditSchool />
        </WrapperSection>
    );
};

export default CreateSchool;
